/**
 * PanelSlider — the light-card range input. Sits in a full-height row so the touch target is the
 * control height, not the 8 px of visible track.
 */

import { CONTROL_H, MOTION } from './tokens';

interface PanelSliderProps {
  min: number;
  max: number;
  step?: number;
  value: number;
  onChange: (value: number) => void;
  ariaLabel?: string;
}

export function PanelSlider({ min, max, step = 1, value, onChange, ariaLabel }: PanelSliderProps) {
  return (
    <div className={`${CONTROL_H} flex items-center`}>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        aria-label={ariaLabel}
        onChange={(e) => onChange(parseFloat(e.target.value))}
        className={`w-full h-2 rounded-full appearance-none bg-neutral-100 ring-1 ring-inset ring-black/5
          cursor-pointer accent-[#93CB55] ${MOTION}
          [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:w-5 [&::-webkit-slider-thumb]:h-5
          [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-[#93CB55]
          [&::-webkit-slider-thumb]:shadow-md [&::-webkit-slider-thumb]:cursor-pointer
          [&::-moz-range-thumb]:appearance-none [&::-moz-range-thumb]:w-4 [&::-moz-range-thumb]:h-4
          [&::-moz-range-thumb]:border-0 [&::-moz-range-thumb]:rounded-full [&::-moz-range-thumb]:bg-[#93CB55]`}
      />
    </div>
  );
}
